import store from "@/store";
import { getAffectedItemLists } from "../order-test-panel/index.js";
import { handleDifferentAndSamePriceList, handleDiscardList } from "../order-test-panel/menu-switch-dialog";

export function addBuildBundlePromoFromDialog(payload, orderTestSupportObj) {
  let { zoomerIds, panelIds, dbsToggle } = payload;
  let { selectedItemList, dbsMap, bundleList, testNodeList, editOrderItemList } = orderTestSupportObj;
  
  // Add selected zoomers as tests
  if (zoomerIds && zoomerIds.length > 0) {
    zoomerIds.forEach(id => {
      store.dispatch("orderTest/addSelectedTest", { id });
    });
  }
  
  // Add selected panels as tests (panels are tests only for now)
  if (panelIds && panelIds.length > 0) {
    panelIds.forEach(id => {
      store.dispatch("orderTest/addSelectedTest", { id });
    });
  }
  
  // Set DBS version if it changed
  if (dbsToggle !== undefined && dbsToggle !== store.state.orderTest.isDbsVersion) {
    store.dispatch("orderTest/setIsDbsVersion", dbsToggle);
    let changeVersionSupportObj = {
      selectedTestList: selectedItemList.filter(item => ["va", "vw"].includes(item.category)),
      selectedDiscountPanelList: selectedItemList.filter(item => item.category === "discountPanel"), 
      selectedCustomPanelList: selectedItemList.filter(item => item.category === "customPanel"), 
      selectedXChooseYPanelList: selectedItemList.filter(item => item.category === "xChooseY"), 
      selectedSeasonalPromoList: selectedItemList.filter(item => item.category === "seasonalPromo"), 
      selectedShortcutList: selectedItemList.filter(item => item.category === "shortcut"),
      dbsMap, 
      testList: testNodeList.map(node => node.value), 
      bundleList,
      editOrderItemList,
    };
    let { discardItemList, differentPriceItemList, samePriceItemList } = getAffectedItemLists(dbsToggle, changeVersionSupportObj);
    handleDiscardList(discardItemList, orderTestSupportObj);
    handleDifferentAndSamePriceList(differentPriceItemList, samePriceItemList, orderTestSupportObj);
  }
}
